import React, { useState, useEffect } from "react";
// import { BASE_URL } from "../_globalConstants.js";

export default function AdminDelete() {
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(true);

    const [orgData, setOrgData] = useState([]);
    const [selectedOrg, setSelectedOrg] = useState(null);

    useEffect(() => {
        if (successMessage) {
            setTimeout(() => setSuccessMessage(false), 3000);
        }
        if (errorMessage) {
            setTimeout(() => setErrorMessage(false), 3000);
        }
    }, [successMessage, errorMessage]);

    useEffect(() => {
        // Fetch the organization data when the component mounts
        async function fetchOrganizationData() {
            try {
                setLoading(true);
                const response = await fetch("/api/admin/company");
                if (response.ok) {
                    const data = await response.json();
                    setOrgData(data.results);
                    setLoading(false);
                } else {
                    setErrorMessage("Failed to fetch organization data.");
                }
            } catch (error) {
                console.error("Failed to fetch organization data.", error);
                setErrorMessage("Failed to fetch organization data.");
            }
            setLoading(false);
        }
        fetchOrganizationData();
    }, []);

    async function deleteOrganization(e) {
        // This function should make a POST request to the backend
        // to delete an organization. 

        e.preventDefault();

        const org_stub = {
            company_name: document.getElementById("name").value,
            company_primary_poc: document.getElementById("poc_name").value,
            company_primary_poc_email: document.getElementById("poc_email").value,
        }

        try {
            // TODO
        } catch (error) {
            console.error("Failed to delete organization.", error);
            setErrorMessage("Failed to delete organization.");
        }
    }

    const stepsComponent = () => {
        // This component returns either a list of organizations or a form to edit the selected organization
        return (
            <div className="org-edit-container">
                {!selectedOrg && (
                    <div className="org-list">
                        {orgData.map((org, index) => (
                            <div
                                key={index}
                                className={`org-item ${selectedOrg && selectedOrg.company_id === org.company_id ? "selected" : ""}`}
                                onClick={() => setSelectedOrg(org)}
                            >
                                {org.company_name}
                            </div>
                        ))}
                    </div>
                )}
                {selectedOrg && (
                    <div>
                        <button onClick={() => setSelectedOrg(null)} 
                            className="back-button">
                                Back
                        </button>

                        <form onSubmit={deleteOrganization} 
                            className="org-edit-form">
                            <h3>Delete Organization</h3>
                            <label>
                                Name: {selectedOrg.company_name}
                            </label>
                            <label>
                                Primary POC: {selectedOrg.company_primary_poc}
                            </label>
                            <label>
                                Email: {selectedOrg.company_primary_poc_email}
                            </label>
                            <button type="submit">Delete Organization</button>
                        </form>
                    </div>
                )}
            </div>
        );
    };

    function Popup({ message, onClose, error }) {
        return (
            <div className={error ? "popup error-popup" : "popup success-popup"}>
                <div className="popup-content">
                    <p>{message}</p>
                    <span className="close" onClick={onClose}>&times;</span>
                </div>
            </div>
        );
    }

    return (
        <div className="admin-delete-container">
            {loading &&
                <div>
                    Loading...
                </div>
            }
            {successMessage && <Popup message={successMessage} onClose={() => setSuccessMessage(false)} error={false} />}
            {errorMessage && <Popup message={errorMessage} onClose={() => setErrorMessage(false)} error={true} />}

            {stepsComponent()}

            {/* DEBUGGING */}
            {/* <div>{JSON.stringify(orgData)}</div> */}
        </div>
    );
    }